export const boxShadow = "0px 4px 24px 0px rgba(21, 6, 36, 0.12)"
export const filterShadow = "drop-shadow(0px 4px 18px rgba(21, 6, 36, 0.12))"
